module.exports = __webpack_public_path__ + "static/recall-9f38be972438a93788633fef405be132.svg";